<script>
	import { derived } from 'svelte/store';
	import { urlFragment } from '../../stores/url-fragment';
	import { onDestroy } from 'svelte';
	import LevelInfo from './LevelInfo.svelte';
	import LevelSelect from './LevelSelect.svelte';

	const pages = {
		levelInfo: LevelInfo,
		levelSelect: LevelSelect,
	};

	// Tie URL menu fragment to the current page being displayed.
	const currentPage = derived( urlFragment, ( urlFragment ) => pages[ urlFragment.menu ] || pages.levelInfo );
	onDestroy( () => urlFragment.setUrlKey( 'menu', undefined ) );
</script>

<svelte:component this={$currentPage} />
